import { render, staticRenderFns } from "./moreAnalytics4.vue?vue&type=template&id=3540f270&scoped=true&"
import script from "./moreAnalytics4.vue?vue&type=script&lang=js&"
export * from "./moreAnalytics4.vue?vue&type=script&lang=js&"
import style0 from "./moreAnalytics4.vue?vue&type=style&index=0&id=3540f270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3540f270",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3540f270')) {
      api.createRecord('3540f270', component.options)
    } else {
      api.reload('3540f270', component.options)
    }
    module.hot.accept("./moreAnalytics4.vue?vue&type=template&id=3540f270&scoped=true&", function () {
      api.rerender('3540f270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/sales/moreAnalytics4.vue"
export default component.exports